import {
  CommonIncidentId,
  SoccerIncidentId,
} from '@collector/sportsapi-client-legacy'

import { HistoryFiltersConfig } from '../../configuration'
import { historyFiltersAttributesConfig } from './historyFiltersAttributesConfig'
import { incidentIdsGroup } from './incidentsGroup'

export const historyFiltersConfig: HistoryFiltersConfig = {
  withConfirmation: true,
  historyFiltersAttributes: historyFiltersAttributesConfig,
  historyFiltersIncidents: [
    SoccerIncidentId.Goal,
    SoccerIncidentId.RedCard,
    SoccerIncidentId.YellowCard,
    SoccerIncidentId.Corner,
    SoccerIncidentId.Penalty,
    SoccerIncidentId.PenaltySavedByGoalkeeper,
    SoccerIncidentId.MissedPenalty,
    SoccerIncidentId.ShotOnTarget,
    SoccerIncidentId.ShotOffTarget,
    SoccerIncidentId.ShotBlocked,
    SoccerIncidentId.Foul,
    SoccerIncidentId.Offside,
    SoccerIncidentId.FreeKick,
    SoccerIncidentId.ThrowIn,
    SoccerIncidentId.Injury,
    incidentIdsGroup,
    SoccerIncidentId.GoalKick,
    SoccerIncidentId.AddedTime,
    SoccerIncidentId.PossibleVAR,
    SoccerIncidentId.VarEnded,
    CommonIncidentId.Betstart,
    CommonIncidentId.Betstop,
    SoccerIncidentId.BookingMarketsDisabled,
    SoccerIncidentId.BookingMarketsEnabled,
    SoccerIncidentId.CornerMarketsDisabled,
    SoccerIncidentId.CornerMarketsEnabled,
    CommonIncidentId.TechnicalProblems,
    SoccerIncidentId.BreakDuringTheGame,
    CommonIncidentId.MatchResumed,
    SoccerIncidentId.WaterBreak,
    SoccerIncidentId.RefereesInjury,
    SoccerIncidentId.InPossession,
    SoccerIncidentId.Attack,
    SoccerIncidentId.DangerousAttack,
    SoccerIncidentId.KickOff,
    SoccerIncidentId.PlayShortHanded,
    SoccerIncidentId.PlayerReturnToPitch,
    SoccerIncidentId.Tackle,
    SoccerIncidentId.Interception,
    SoccerIncidentId.BallSkills,
    SoccerIncidentId.Error,
    SoccerIncidentId.BigChanceCreated,
  ],
}
